module.exports = __webpack_public_path__ + "static/icon-chengben.6a43ba63.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon-chengben.png
// module id = 308
// module chunks = 2